import React from "react";
import { useNavigate } from "react-router-dom";
import InviteCodeForm from "./InviteCodeForm";
import { SmallLockIcon } from "./icons";

// What a private league shows someone who arrived with only its address.
//
// A slug is not a credential: knowing (or being forwarded) qushi.io/join/
// carter-investing-club tells you a league exists and nothing else. So this stands
// in front of the league instead of its preview — no name, no dates, no members,
// no description. The one way through is the organiser's invite code.
//
// Membership is checked before this ever renders, so a member never sees it again.
const LeagueInviteGate = () => {
  const navigate = useNavigate();

  return (
    <div className="mt-16 md:mt-24 pb-12">
      <div className="max-w-md mx-auto px-4">
        <div className="rounded-2xl border border-gray-200 bg-white p-6 md:p-8 text-center">
          <span className="inline-flex w-12 h-12 rounded-full bg-[#E9F7F0] items-center justify-center">
            <SmallLockIcon className="w-6 h-6" />
          </span>

          <h1 className="mt-3 font-montserrat font-bold text-title-subpage text-pageTitle">
            Invite only
          </h1>
          <p className="mt-1 text-sm text-secondary">
            This league isn't public. Enter the invite code your organizer shared
            to see it.
          </p>

          <div className="mt-5 text-left">
            <InviteCodeForm
              submitLabel="Continue"
              onResolved={(result) =>
                navigate(`/contest/join/${result.code}`, {
                  state: { game: result.game, via: "code" },
                })
              }
            />
          </div>

          <p className="mt-4 text-sm text-secondary">No code? You're not on the list yet.</p>
          <p className="mt-0.5 text-sm font-semibold text-[#0F172A]">
            Hit up your organizer.
          </p>

          <button
            type="button"
            onClick={() => navigate("/contest")}
            className="mt-5 text-sm font-medium text-[#0F4146] hover:underline"
          >
            Back to League Play
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeagueInviteGate;
